const BLOCKED = new Set(['NotAllowedError', 'PermissionDeniedError', 'SecurityError']);
const NOT_FOUND = new Set(['NotFoundError', 'DevicesNotFoundError', 'OverconstrainedError', 'ConstraintNotSatisfiedError']);
const IN_USE = new Set(['NotReadableError', 'TrackStartError', 'AbortError']);
const errorName = (error) => {
    if (error && typeof error === 'object') {
        const named = error;
        if (typeof named.name === 'string' && named.name !== 'Error' && named.name !== 'RtcError') {
            return named.name;
        }
        if (named.cause !== undefined && named.cause !== error) {
            return errorName(named.cause);
        }
    }
    return '';
};
export const classifyDeviceError = (error) => {
    const name = errorName(error);
    if (BLOCKED.has(name)) {
        return 'blocked';
    }
    if (NOT_FOUND.has(name)) {
        return 'not_found';
    }
    if (IN_USE.has(name)) {
        return 'in_use';
    }
    return 'failed';
};
export const deviceKindOf = (kind) => {
    if (kind === 'audioinput') {
        return 'microphone';
    }
    if (kind === 'videoinput') {
        return 'camera';
    }
    return undefined;
};
export const withDeviceIssue = (issues, kind, issue) => {
    if (issues?.[kind] === issue) {
        return issues;
    }
    const next = { ...issues };
    if (issue) {
        next[kind] = issue;
    }
    else {
        delete next[kind];
    }
    return Object.keys(next).length > 0 ? next : undefined;
};
